import * as React from "react";
import { createSearchParams, useNavigate, useParams, useSearchParams, } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "../../../../stylesheets/components/Reports/HoldingReports/HoldingReports.scss";
import loaderGIF from "../../../../assets/images/Reports/loaderGIF.gif";
import StockDetails from "../StockViewInDetail/StockDetails";
import { getQueryParameterName } from "../../../../utils/urlHelper";
import ProfitAndLossReport from "../../../Reports/PNLReports/ProfitAndLossReport";
import TaxMainComponent from "../../../../components/Reports/TaxReports/TaxMainComponent";
import { fetchAccountDetails } from "../../../../redux/reducers/Reports/accountDetailsThunk";
import { useDispatch, useSelector } from "react-redux";
import { JwtTokenNestThunk } from "../../../../redux/reducers/JwtTokenNestThunk";
import { ExtPlatDataRetrieveThunks } from "../../../../redux/reducers/ExtPlatDataRetrieve";
import { Edelweisslogo } from "../../../../utils/edelweisslogo-header";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { GTMService } from "@di";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import HoldingReportComponent from "./HoldingReports/HoldingReportComponent";
import familyDi from "@frameworks/web/components/Reports/FamilyTagging/di/servicelocator";
import { StockDetailsEnum } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import { TransactionType } from "@domains/aggregates/interfaces/Reports/iPNLTransactionReport";
import { IPNLSubTabs, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import moment from "moment";
import { usePageVisibility } from "@frameworks/web/components/generic/customHooks/usePageVisibility";
import PNLDI from "@frameworks/web/components/Reports/PNLReports/di/servicelocator";
import OtherReports from "../OtherReports";
import EditTxnsFromSideBar from "./EditTxnsFromSideBar";
import HoldingDashboard from "./HoldingReports/HoldingDashboard";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { REPORT_TAB_KEYS, REPORT_TAB_NAMES, ReportTabKeys } from "../constants";
import { useParamsContext } from "@frameworks/web/components/generic/customHooks/ParamsContext";
import _ from "underscore";
import TransactionHistoryMain from "@frameworks/web/components/Reports/TransactionHistory/TransactionHistoryMain";
import { useState } from "react";
import AifPdfDownloadStatus from "../AifPdfDownloadStatus";
const HoldingPositionReports = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isVisible = usePageVisibility();
    const { loginOrigin } = useParams();
    const reportTabKey = getQueryParameterName("reportName");
    const loginToken = getQueryParameterName("jwt_token");
    const platform = getQueryParameterName("platform");
    const userID = getQueryParameterName("UserId");
    const exToken = getQueryParameterName("TokenId");
    const token = getQueryParameterName("token");
    // UI States
    const [loader, setLoader] = React.useState(false);
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const ACTIVE_KEY = ReportTabKeys.get(reportTabKey ? reportTabKey : REPORT_TAB_KEYS.Dashboard).key;
    const [searchParams, setSearchParams] = useSearchParams();
    // PNL States
    const [pnlKey, setPnlKey] = React.useState(IPNLSubTabs.ALL);
    const [tillDateSelectedPNL, setTillDateSelectedPNL] = React.useState(false);
    const [defaultSideBarTab, setDefaultSideBarTab] = React.useState(StockDetailsEnum.OVERVIEW);
    const [assetType, setAssetType] = React.useState();
    const [editableRecord, setEditableRecord] = React.useState(null);
    const [showEditablePopup, setShowEditablePopup] = React.useState(false);
    const [downloadAif, setDownloadAif] = useState(false);
    const [summaryParameters, setSummaryParameters] = React.useState();
    const [holdingStockDetail, setHoldingStockDetail] = React.useState(null);
    const holdingsDetails = useSelector((state) => { var _a, _b; return (_b = (_a = state.holdingReport) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.HoldingDetails; });
    // Redux selectors
    const PNLStreamFromStore = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.pnlReport) === null || _a === void 0 ? void 0 : _a.stream; }, _.isEqual);
    const showShimmer = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.jwtTokenNestTraderReducer) === null || _a === void 0 ? void 0 : _a.showShimmer; });
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const selectedRowIndex = useSelector((state) => state.holdingReport.selectedRowIndex);
    const handleTabSelection = (key) => {
        if (key === ACTIVE_KEY)
            return;
        if ((ACTIVE_KEY === REPORT_TAB_KEYS.Holdings &&
            key === REPORT_TAB_KEYS.Dashboard) ||
            (ACTIVE_KEY === REPORT_TAB_KEYS.Dashboard &&
                key === REPORT_TAB_KEYS.Holdings)) {
            // Retain when switching between holding & dashboard
            familyDi.familyTagging.setStopFamilyAPICall(true);
        }
        else {
            familyDi.familyTagging.setStopFamilyAPICall(false);
            familyDi.familyTagging.setSelectedFamilyMember("", null);
        }
        // setHeadingName(getReportHeadingName(key));
        PNLDI.pnlReport.saveProdAssetDropDown(null);
        PNLDI.pnlReport.viewTransactionClickScrollerPosition = 0;
        PNLDI.pnlReport.LThreeWindowbackClick = false;
        PNLDI.pnlReport.pnlToggleStream(false);
        navigate({
            pathname: "",
            search: createSearchParams({
                reportName: key,
            }).toString(),
        });
        PNLDI.pnlReport.storeSelectedPNLStockDetails({
            tradeDetails: null,
            transactionType: null,
            assetType: null,
            fromDate: "",
            toDate: "",
            edelweissProductCode: null,
        });
        GTMService.gtmService(new ReportGAEvents(`${ReportTabKeys.get(key).title} ${ReportsGTMConstants.Report}`, ReportsGTMConstants.NewReports, `${ReportTabKeys.get(key).title} ${ReportsGTMConstants.Report}`));
    };
    //hooks
    const { routeParams, setRouteParams } = useParamsContext();
    // Scroll handling
    const ElementHoldingReportToDisableScroll = document.querySelector("#holding-table");
    const disableOutScroll = (value) => {
        if (value && openDrawer) {
            document.body.classList.remove("flow-overlay");
            disableBodyScroll(ElementHoldingReportToDisableScroll, {
                reserveScrollBarGap: true,
            });
        }
        else {
            document.body.classList.add("flow-overlay");
            enableBodyScroll(ElementHoldingReportToDisableScroll);
        }
    };
    // Transaction related functions
    const setPNLSummaryParameters = () => {
        if (holdingStockDetail && assetType) {
            const summaryObj = {
                isin: holdingStockDetail.quote.isin,
                scripName: holdingStockDetail.scripName,
                companyName: holdingStockDetail.quote.description,
                qty: holdingStockDetail.quantity,
                ltp: holdingStockDetail.quote.lastTradedPrice,
                scripIdentifier: holdingStockDetail.scripIdentifier,
                fromDate: moment().subtract(2, "days").toDate().toString(),
                toDate: moment().subtract(1, "days").toDate().toString(),
                transactionType: TransactionType.UNREALISED,
                assetType: assetType,
                change: holdingStockDetail.quote.change,
                changePercentage: holdingStockDetail.quote.changePercentage,
            };
            setSummaryParameters(summaryObj);
        }
    };
    const getOriginalTxns = (record) => {
        const payload = {
            pnLEditSplitRequests: [{ transactionId: record.transactionId }],
        };
        PNLDI.pnlTransactionReport.getOriginalTxns(payload);
    };
    const editTransaction = (txn) => {
        getOriginalTxns(txn);
        setEditableRecord(txn);
        setPNLSummaryParameters();
        setShowEditablePopup(true);
        setOpenDrawer(false);
    };
    const item = holdingsDetails[selectedRowIndex];
    // Auth setup
    const setJwtToken = React.useCallback(() => {
        if (loginToken !== null && (platform === "tx3" || platform === "NT")) {
            localStorage.setItem("jwt_token", loginToken !== null ? loginToken : localStorage.getItem("jwt_token"));
            if (platform === "tx3") {
                localStorage.setItem("lgnSrc", "X");
                dispatch(ExtPlatDataRetrieveThunks(token));
            }
        }
    }, [dispatch, loginToken, platform, token]);
    const setJwtTokenForNestTrader = React.useCallback(() => {
        if (userID && exToken) {
            const payload = {
                userId: userID,
                extoken: exToken,
            };
            dispatch(JwtTokenNestThunk(payload));
        }
    }, [dispatch, exToken, userID]);
    // Effects
    React.useEffect(() => {
        setLoader(showShimmer);
    }, [showShimmer]);
    React.useEffect(() => {
        // Initialize the component
        setJwtToken();
        dispatch(fetchAccountDetails());
        setJwtTokenForNestTrader();
        // setHeadingName(getReportHeadingName(reportTabKey));
        // Handle selected row
        if (selectedRowIndex >= 0) {
            setOpenDrawer(true);
        }
        // Initialize PNL Store
        if (!PNLDI.pnlReport.LThreeWindowbackClick) {
            PNLDI.pnlReport.initPNLStore();
            sessionStorage.setItem("initialLoad", "true");
        }
        // Cleanup function for page unload
        const handleBeforeUnload = () => {
            PNLDI.pnlReport.removeSessionFilters();
            sessionStorage.removeItem("fromDate");
            sessionStorage.removeItem("toDate");
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);
    React.useEffect(() => {
        if (PNLStreamFromStore)
            PNLDI.pnlReport.getPNLStreamData(!isVisible);
    }, [isVisible]);
    // Effect to load saved params when report tab changes
    React.useEffect(() => {
        if (reportTabKey) {
            const savedParams = routeParams.get(reportTabKey);
            // Only set search params if we have saved params and they're different
            if (savedParams) {
                // Check if current params are different from saved params
                const currentParamsString = searchParams.toString();
                const savedParamsString = savedParams.toString();
                if (currentParamsString !== savedParamsString) {
                    setSearchParams(savedParams);
                }
            }
        }
    }, [reportTabKey]);
    // Effect to save params when they change
    React.useLayoutEffect(() => {
        if (reportTabKey === ACTIVE_KEY) {
            // Create a copy of searchParams to avoid reference issues
            const paramsCopy = new URLSearchParams(searchParams.toString());
            setRouteParams(reportTabKey, paramsCopy);
        }
    }, [reportTabKey, searchParams]);
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { id: "holding" },
            React.createElement("div", { className: "container mt-3", id: "holdings-heading" },
                React.createElement("div", { className: "row" }, loginOrigin !== LoginSource.SALES && React.createElement(Edelweisslogo, null))),
            loader ? (React.createElement("div", { className: "img-loader" },
                React.createElement("img", { className: "loader", src: loaderGIF, alt: "loaderGIF" }))) : (React.createElement("div", { className: "container", id: "holdings-tabs" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "holding-tabs ps-lg-0 pe-lg-0" },
                        React.createElement(Tabs, { defaultActiveKey: reportTabKey || ACTIVE_KEY, id: "myTab", activeKey: ACTIVE_KEY, onSelect: handleTabSelection, className: "p-lg-0" },
                            React.createElement(Tab, { title: "Dashboard", id: "dashboard-tab", eventKey: REPORT_TAB_KEYS.Dashboard }, ACTIVE_KEY === REPORT_TAB_KEYS.Dashboard && (React.createElement(HoldingDashboard, null))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.Holdings, title: REPORT_TAB_NAMES.Holdings, id: "holdings-tab" }, ACTIVE_KEY === REPORT_TAB_KEYS.Holdings && (React.createElement(React.Fragment, null,
                                React.createElement(HoldingReportComponent, { openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, loader: loader, setLoader: setLoader, setAssetType: setAssetType, setDefaultSideBarTab: setDefaultSideBarTab, setHoldingStockDetail: setHoldingStockDetail }),
                                React.createElement("section", { className: "dynamic-stockdetails-body" },
                                    openDrawer && selectedRowIndex >= 0 && (React.createElement(StockDetails, { openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, selectedRowIndex: selectedRowIndex, disableOutScroll: disableOutScroll, loader: loader, setLoader: setLoader, assetType: assetType, defaultSideBarTab: defaultSideBarTab, setDefaultSideBarTab: setDefaultSideBarTab, fromDate: moment().subtract(2, "days").toDate(), endDate: moment().subtract(1, "days").toDate(), editTransaction: editTransaction, isMyaccount: (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) === myAccCode, accCode: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, setDownloadAif: setDownloadAif })),
                                    downloadAif && (React.createElement(AifPdfDownloadStatus, { selectedData: item, setDownloadAif: setDownloadAif, downloadAif: downloadAif }))),
                                React.createElement(EditTxnsFromSideBar, { editableRecord: editableRecord, setShowEditablePopup: setShowEditablePopup, showEditablePopup: showEditablePopup, holdingStockDetail: holdingStockDetail, editTransaction: editTransaction, assetType: assetType, setSwitchKey: setOpenDrawer, summaryParamters: summaryParameters })))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.PNL, title: REPORT_TAB_NAMES.PNL, id: "profit&loss-tab" }, ACTIVE_KEY === REPORT_TAB_KEYS.PNL && (React.createElement("div", { id: "profit&loss" },
                                React.createElement(ProfitAndLossReport, { loader: loader, setLoader: setLoader, tabKey: pnlKey, setTabKey: setPnlKey, setTillDateSelected: setTillDateSelectedPNL, tillDateSelected: tillDateSelectedPNL })))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.TAX, title: "Tax", id: "tax-tab" }, ACTIVE_KEY === REPORT_TAB_KEYS.TAX && (React.createElement("div", { id: "Tax" },
                                React.createElement(TaxMainComponent, null)))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.TRANSACTIONHISTORY, title: REPORT_TAB_KEYS.TRANSACTIONHISTORY, id: "Transactions" }, ACTIVE_KEY === REPORT_TAB_KEYS.TRANSACTIONHISTORY && (React.createElement(TransactionHistoryMain, null))),
                            React.createElement(Tab, { eventKey: REPORT_TAB_KEYS.OTHER, title: "Other reports", id: "other-tab" }, ACTIVE_KEY === REPORT_TAB_KEYS.OTHER && React.createElement(OtherReports, null))))))))));
};
export default HoldingPositionReports;
